import useSWRMutation from 'swr/mutation';
import fetcher from 'lib/fetcher';
import { toast } from 'react-toastify';

const useCopyFavoriteList = (id: number) => {
  async function fetchCopyFavoriteList(
    url: string,
    { arg }: { arg: { title: string; userId: number } },
  ) {
    try {
      const data = await fetcher.post(url, { ...arg });

      if (data?.error) {
        return toast.error(`Не удалось скопировать список: ${data?.error}`, {
          autoClose: 5000,
        });
      }

      toast.success('Спиосок скопирован', { autoClose: 5000 });
      return data.result;
    } catch (error) {
      throw toast.error('Не удалось скопировать список', { autoClose: 5000 });
    }
  }

  const { data, error, isMutating, ...rest } = useSWRMutation(
    `/favourites/list/${id}/copy`,
    fetchCopyFavoriteList,
  );

  return { data, error, isMutating, ...rest };
};
export default useCopyFavoriteList;
